import {useTranslation} from 'react-i18next'
import {EliminarConMotivoDialog} from '@/components/eliminar-con-motivo-dialog'
import {PorQue} from '@/components/ui/por-que'
import {useMotivoError} from '@/hooks/common/use-motivo-error'
import {useDeleteIncidente, type Incidente} from '@/hooks/sgsst/incidentes/use-incidentes'
import {translateApiError} from '@/lib/errors'
import {formatShortDate} from '@/lib/risk'

export function EliminarIncidenteDialog({
  businessId,
  incidente,
  open,
  onOpenChange,
  onDeleted,
}: {
  businessId: string
  incidente: Incidente
  open: boolean
  onOpenChange: (open: boolean) => void
  onDeleted?: () => void
}) {
  const {t} = useTranslation()
  const eliminar = useDeleteIncidente(businessId)
  const {error, setError, clear} = useMotivoError()

  return (
    <EliminarConMotivoDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('incidentes.eliminar.title')}
      description={(contenedor) => (
        <>
          <p>
            {t('incidentes.eliminar.desc', {
              tipo: t(`incidentes.tipo.${incidente.tipo}`).toLowerCase(),
              gravedad: t(`incidentes.gravedad.${incidente.gravedad_reportada}`).toLowerCase(),
              afectado: incidente.afectado_nombre ?? t('incidentes.eliminar.sinAfectado'),
              fecha: formatShortDate(incidente.evento_fecha),
              estado: t(`incidentes.estado.${incidente.estado}`),
            })}
          </p>
          <div className="mt-2">
            <PorQue
              label={t('incidentes.eliminar.queQuedaLabel')}
              contenedor={contenedor}
              testId="eliminar-incidente-que-queda"
              contenidoTestId="eliminar-incidente-que-queda-contenido">
              {t('incidentes.eliminar.queQueda')}
            </PorQue>
          </div>
        </>
      )}
      motivoLabel={t('incidentes.eliminar.motivoLabel')}
      motivoPlaceholder={t('incidentes.eliminar.motivoPlaceholder')}
      confirmLabel={t('incidentes.eliminar.confirm')}
      testIdPrefix="eliminar-incidente"
      pending={eliminar.isPending}
      error={error}
      onReset={() => {
        clear()
        eliminar.reset()
      }}
      onConfirm={(motivo) =>
        eliminar.mutate(
          {incidenteId: incidente.id, motivo},
          {
            onSuccess: () => {
              onDeleted?.()
              onOpenChange(false)
            },
            onError: (err) => setError(translateApiError(err)),
          }
        )
      }
    />
  )
}
